import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner, Button } from 'react-bootstrap';

const EditEmployee = () => {
  const [employee, setEmployee] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
    pic: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch employee data
  const fetchEmployee = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employees/${id}`);

      if (!response.ok) {
        throw new Error('Employee data fetch failed');
      }

      const result = await response.json();

      if (result) {
        setEmployee(result);
      } else {
        setEmployee({
          id: '',
          name: '',
          email: '',
          phone: '',
          pic: '',
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployee();
  }, [id]);

  // Handle input changes, including file input
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'pic' && files && files.length > 0) {
      setEmployee((prev) => ({
        ...prev,
        pic: files[0], // Store file object
      }));
    } else {
      setEmployee((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage(null);

    const formPayload = new FormData();
    formPayload.append('name', employee.name || '');
    formPayload.append('email', employee.email || '');
    formPayload.append('phone', employee.phone || '');

    if (employee.pic) {
      formPayload.append('pic', employee.pic);
    }

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employee_upd/${id}`, {
        method: 'POST',
        body: formPayload,
      });

      if (!response.ok) {
        throw new Error('Failed to update employee');
      }

      setSuccessMessage('Employee updated successfully!');
      setError(null);

      // Optionally reload data after success to show fresh info
      setTimeout(() => {
        // You can either reload the page or refetch the employee data
        // window.location.reload();

        // Or refetch the employee data without page reload:
        fetchEmployee();
      }, 1500);
    } catch (err) {
      setError(err.message);
      setSuccessMessage(null);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status" />
        <span className="ms-3">Loading...</span>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="container mt-5">
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        <div className="card shadow">
          <div className="card-header">
            <h2>Update Employee</h2>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                 <input type="text" className="form-control" id="name" name="name" value={employee?.name || ''} onChange={handleChange} placeholder="Enter Employee Name" required />
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                 <input type="email" className="form-control" id="email" name="email" value={employee?.email || ''} onChange={handleChange} placeholder="Enter Employee Email" required />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className="form-label"> Phone</label>
                 <input type="tel" className="form-control" id="phone" name="phone" value={employee?.phone || ''} onChange={handleChange} placeholder="Enter Employee Phone Number" required />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Upload Picture</label>
                  <input type="file" className="form-control" name="pic" accept="image/*" onChange={handleChange} />
                  {employee.pic && typeof employee.pic === 'string' && (
                    <img
                      src={`https://apiaksharaconnect.aksharafinalytics.in/${employee.pic}`}
                      alt="Manager"
                      className="img-thumbnail mt-2"
                      width="75"
                    />
                  )}
                </div>
              </div>

              <center>
                <Button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Updating...
                    </>
                  ) : (
                    'Update'
                  )}
                </Button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditEmployee;
